module.exports = __webpack_public_path__ + "static/media/arrow-right.4e74ad62.svg";